module.exports = "<svg width=\"15\" height=\"11\" viewBox=\"0 0 15 11\" xmlns=\"http://www.w3.org/2000/svg\"><title>Combined Shape</title><path d=\"M2.652 2.6H14.14v7.832H2.652V2.6zM1.352 0h9.753v1.3H1.352V0zm-1.3 0h1.3v7.803h-1.3V0z\" fill=\"#5F021C\" fill-rule=\"evenodd\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/icons/gallery_icon.svg
// module id = ./node_modules/raw-loader/index.js!./src/icons/gallery_icon.svg
// module chunks = 168707334958949